
const categories = {
    "heading": "Discover more ways to be entertained.",
    "subHeading1": "Get access to amazing benefits just for being an AT&T customer.",
    "subHeading2":"Enjoy great deals on AT&T products and services, accessories, gift cards, entertainment and more!",
    "sectionHeading": "Benefits included:",
    "cta": {
      "href": "https://www.att.com/olam/loginAction.olamexecute?pId=Passthru_ATT_Thank_You",
      "color": "primary",
      "label": "Sign in to see all  benefits",
      "id": "signIn",
      "newTab": "false",
      "round": false
  },
    "sections": [
      {
        "image": {
          src: require('../images/categories/OlderWoman.jpg'),
          altText: "Friends on a train"
        },
        "vendors": [
          {
            "heading": "Right To You",
            "bodyCopy": "Get same-day delivery and expert setup on new devices."
          },
          {
            "heading": "Premier Support",
            "bodyCopy": "Get a dedicated expert to help with all your service needs."
          },
          {
            "heading": "AT&T Products",
            "bodyCopy": "We’ve got the phones, accessories and gift cards that will keep you connected."
          },
          {
            "heading": "VIP Giveaways",
            "bodyCopy": "Chances to win trips, giveaways and VIP tickets to sporting events and premieres."
          },          
          {
            "heading": "Friday Access",
            "bodyCopy": "Weekly chances to win gift cards, promotions and more."
          },
          {
            "heading": "",
            "bodyCopy": ""
          }
        ]
      }
    ]
}

module.exports = categories;
